import React, { useState } from "react";
import { Form, Input, Button, Typography } from "antd";
import "firebase/auth";
import Auth from "../../api/auth";
import { withTheme } from "styled-components";
import { useIntl } from "react-intl";
import LoginTemplate from "../../components/templates/LoginTemplate";
import { MailOutlined } from "@ant-design/icons";
import { ReactComponent as Login } from "../../assets/login.svg";
const { Text } = Typography;

const Forgot = (props) => {
  const intl = useIntl();
  const [authError, setAuthError] = useState(null);
  const [feedback, setFeedback] = useState(null);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    Auth.sendPasswordResetEmail(values.email)
      .then(function () {
        setAuthError(null);
        setFeedback(true);
        setLoading(false);
      })
      .catch(function (error) {
        setAuthError(error.message);
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const usernameLabel = intl.formatMessage({
    id: "app.forms.email",
  });

  const validateMessages = {
    required: `${intl.formatMessage({
      id: "app.forms.requiredMail",
    })}`,
    types: {
      email: `${intl.formatMessage({
        id: "app.forms.validMail",
      })}`,
    },
  };
  return (
    <LoginTemplate
      title={intl.formatMessage({
        id: "app.forms.user.reset_title",
      })}
      subTitle={intl.formatMessage({
        id: "app.forms.user.reset_subtitle",
      })}
      image={<Login />}
    >
      <Form
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        validateMessages={validateMessages}
      >
        <Form.Item name={"email"} rules={[{ required: true, type: "email" }]}>
          <Input prefix={<MailOutlined />} placeholder={usernameLabel} />
        </Form.Item>

        {authError ? (
          <Text
            style={{
              margin: "-20px 0 20px ",
              width: "300px",
              color: "#a61d24",
            }}
          >
            {authError}
          </Text>
        ) : null}
        <Form.Item>
          <Button loading={loading} block type="primary" htmlType="submit">
            {intl.formatMessage({
              id: "app.actions.send",
            })}
          </Button>
        </Form.Item>
      </Form>
      {feedback ? (
        <Text>
          {intl.formatMessage({
            id: "app.forms.user.resetLinkSent",
          })}
        </Text>
      ) : null}
    </LoginTemplate>
  );
};

export default withTheme(Forgot);
